module.exports = __webpack_public_path__ + "static/twitter-11ce1056510aa211993c331cf8b3868b.png";